// equivalent to python defaultdict

const defaultdict = (getDefaultValue: any, initialObject: any = {}) => {
  if (typeof getDefaultValue !== 'function') {
    throw new Error('getDefaultValue must be a function');
  }

  if (typeof initialObject !== 'object' || initialObject === null) {
    throw new Error('initialObject must be an object');
  }

  return new Proxy(initialObject || {}, {
    get: (target: any, name: string) => {
      if (!(name in target)) {
        target[name] = getDefaultValue(name);
      }

      return target[name];
    },
  });
};

export default defaultdict;
